/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Editor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromImageeditor from 'Logic/ImageEditor.js'
import ImageEditor from 'DesignSystem/ImageEditor/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Editor({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content/Editor"
  
}) {
let imageEditorSrcValueData = fromData.useDataValue({ viewPath,
context: 'image',
path: 'editor_src',
})
let imageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromImageeditor.getAspectRatio,
})
let imageSlotKeyValueData1 = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromImageeditor.getWillRenderCanvas,
})
let onInit = fromHelpers.useOnInit({
  children,
  viewPath
  
})
let onUpdate = fromHelpers.useOnUpdate({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ImageEditor
  viewPath={`${viewPath}/ImageEditor`}
 data="image.editor_src"
 src={imageEditorSrcValueData}
 data="image.slot_key"
 format="/Logic/ImageEditor.js getAspectRatio"
 aspectRatio={imageSlotKeyValueData}
 data="image.slot_key"
 format="/Logic/ImageEditor.js getWillRenderCanvas"
 willRenderCanvas={imageSlotKeyValueData1}
 enableButtonExport={false}
 limitToImage={false}
 onInit={onInit}
 onUpdate={onUpdate}
/>
{children}
</React.Fragment>)
}